import React, { useEffect,useMemo,useState,} from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const DispatchIndent = () => {

  const [tab, setTab] = useState("add");
  const [type, setType] = useState("");
  const [masters, setMasters] = useState([]);
  const [mastId, setMastId] = useState("");
  const [viewMastId, setViewMastId] = useState("");
  const [data, setData] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [dispatchDate, setDispatchDate] = useState("");
  const [loading, setLoading] = useState(false);

  const getStatus = (reqQty, dispQty) => {
    if (dispQty <= 0) {
      return "Not Dispatch";
    }
    if (dispQty < reqQty) {
      return "Partial Dispatch";
    }
    return "Completed";
  };
  const loadMasters = async () => {
    try {
      const res = await axios.get(
        `${REACT_APP_API_URL}api/dispatch-indent/req-list`,
        {
          timeout: 15000,
        }
      );
      console.log(
        "REQUEST LIST => ",
        res.data
      );
      if (Array.isArray(res.data)) {
        setMasters(res.data);
      } else {
        setMasters([]);
      }
    } catch (err) {
      console.log(err);
      alert(
        err.response?.data?.message ||
          "Failed to load request list"
      );
    }
  };
  useEffect(() => {
    loadMasters();
  }, []);
  const filteredMasters = useMemo(() => {
    if (!type) return [];
    return masters.filter((m) => {
      const orderBy = String(
        m?.OrderBy || ""
      )
        .trim()
        .toLowerCase();
      if (type === "HO") {
        return (
          orderBy === "head office" ||
          orderBy === "head-office" ||
          orderBy === "headoffice" ||
          orderBy === "ho"
        );
      }
      if (type === "TIC") {
        return orderBy === "tic";
      }
      if (type === "HOTEL") {
        return orderBy === "hotel";
      }
      return false;
    });
  }, [masters, type]);
  const loadData = async () => {
    if (!type) {
      alert("Select Request By");
      return;
    }
    if (!mastId) {
      alert("Select Request No");
      return;
    }
    try {
      const res = await axios.get(
        `${REACT_APP_API_URL}api/dispatch-indent/view`,
        {
          params: {
            reqIndentMastId:
              Number(mastId),
          },
          timeout: 15000,
        }
      );
      console.log( "LOAD DATA => ", res.data);
      const updated = ( res.data || [] ).map((d) => ({
        ...d,
        qty: "",
        status: getStatus(
          Number(d.NoOfItems || 0),
          Number(
            d.NoOfItemsDisp || 0
          )
        ),
      }));
      setData(updated);
      if (updated.length === 0) {
        alert("No Data Found");
      }
    } catch (err) {
      console.log(err);
      alert(
        err.response?.data?.message ||
          "Error loading data"
      );
    }
  };
  const loadViewData = async () => {
    if (!viewMastId) {
      alert("Select Request No");
      return;
    }
    try {
      const res = await axios.get(
        `${REACT_APP_API_URL}api/dispatch-indent/view`,
        {
          params: {
            reqIndentMastId:
              Number(viewMastId),
          },
          timeout: 15000,
        }
      );
      console.log("VIEW DATA => ",res.data);
      setViewData(res.data || []);
    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Error loading view data");
    }
  };
  const handleQtyChange = (index,value) => {
    const updated = [...data];
    if (value === "") {
      updated[index].qty = "";
      updated[index].status =
        getStatus(
          Number(
            updated[index]
              .NoOfItems || 0
          ),
          Number(
            updated[index]
              .NoOfItemsDisp || 0
          )
        );
      setData(updated);
      return;
    }
    if (!/^\d+$/.test(value)) {
      alert("Only numeric value allowed");
      return;
    }
    if (value.includes(".")) {
      alert("Decimal qty not allowed");
      return;
    }
    const qty = parseInt(value);
    if (
      !Number.isInteger(qty)
    ) {
      alert("Invalid Qty");
      return;
    }
    if (qty <= 0) {
      alert(
        "Qty must be greater than 0"
      );
      return;
    }

    const reqQty = Number(
      updated[index]
        .NoOfItems || 0
    );

    const dispQty = Number(
      updated[index]
        .NoOfItemsDisp || 0
    );

    // COMPLETED

    if (dispQty >= reqQty) {

      alert(
        "Item already completed"
      );

      return;
    }

    const remainingQty =
      reqQty - dispQty;

    if (qty > remainingQty) {

      alert(
        `Maximum allowed qty is ${remainingQty}`
      );

      return;
    }

    updated[index].qty = qty;

    updated[index].status =
      getStatus(
        reqQty,
        dispQty + qty
      );

    setData(updated);
  };

  // ================= DISPATCH =================

  const dispatchItems = async () => {

    if (loading) return;

    if (!type) {
      alert("Select Request By");
      return;
    }

    if (!mastId) {
      alert("Select Request No");
      return;
    }

    if (!dispatchDate) {
      alert(
        "Select Dispatch Date"
      );
      return;
    }

    if (data.length === 0) {
      alert("No Data Found");
      return;
    }

    // DATE VALIDATION

    const selectedDate =
      new Date(dispatchDate);

    const currentDate =
      new Date();

    selectedDate.setHours(
      0,
      0,
      0,
      0
    );

    currentDate.setHours(
      0,
      0,
      0,
      0
    );

    if (
      selectedDate > currentDate
    ) {

      alert(
        "Future date not allowed"
      );

      return;
    }

    // ITEMS

    const items = data
      .filter(
        (d) =>
          Number(d.qty) > 0
      )
      .map((d) => ({
        reqIndentId: Number(
          d.ReqIndentId
        ),
        qty: Number(d.qty),
      }));

    if (items.length === 0) {

      alert(
        "Enter Dispatch Qty"
      );

      return;
    }

    try {

      setLoading(true);

      const res =
        await axios.post(
          `${REACT_APP_API_URL}api/dispatch-indent/add`,
          {
            dispatchDate,
            createdBy: 1,
            items,
          },
          {
            timeout: 15000,
          }
        );

      alert(
        res.data?.message ||
          "Dispatch Successful"
      );

      // RESET

      setData([]);

      setMastId("");

      setDispatchDate("");

      loadMasters();

    } catch (err) {

      console.log(err);

      alert(
        err.response?.data?.message ||
          "Dispatch failed"
      );

    } finally {

      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-3">

      <h4 className="mb-3">
        Dispatch Indent
      </h4>

      {/* ================= TAB ================= */}

      <div className="mb-3">

        <button
          className={`btn ${
            tab === "add"
              ? "btn-primary"
              : "btn-secondary"
          } me-2`}
          onClick={() =>
            setTab("add")
          }
        >
          Add
        </button>

        <button
          className={`btn ${
            tab === "view"
              ? "btn-primary"
              : "btn-secondary"
          }`}
          onClick={() =>
            setTab("view")
          }
        >
          View
        </button>
      </div>

      {/* ================= ADD ================= */}

      {tab === "add" && (
        <>
          <div className="row mb-3">

            {/* REQUEST BY */}

            <div className="col-md-3">

              <label className="form-label">
                Request By
              </label>

              <select
                className="form-control"
                value={type}
                onChange={(e) => {

                  setType(
                    e.target.value
                  );

                  setMastId("");

                  setData([]);

                  setDispatchDate(
                    ""
                  );
                }}
              >
                <option value="">
                  Select
                </option>

                <option value="HO">
                  Head Office
                </option>

                <option value="TIC">
                  TIC
                </option>

                <option value="HOTEL">
                  Hotel
                </option>
              </select>
            </div>

            {/* REQUEST NO */}

            <div className="col-md-4">

              <label className="form-label">
                Request No
              </label>

              <select
                className="form-control"
                value={mastId}
                onChange={(e) =>
                  setMastId(
                    e.target.value
                  )
                }
              >
                <option value="">
                  Select
                </option>

                {filteredMasters.map(
                  (m) => (
                    <option
                      key={
                        m.ReqIndentMastId
                      }
                      value={
                        m.ReqIndentMastId
                      }
                    >
                      {
                        m.ReqIndentNo
                      }
                    </option>
                  )
                )}
              </select>

              {type &&
                filteredMasters.length ===
                  0 && (
                  <small className="text-danger">
                    No Request Found
                  </small>
                )}
            </div>

            {/* DATE */}

            <div className="col-md-3">

              <label className="form-label">
                Dispatch Date
              </label>

              <input
                type="date"
                className="form-control"
                value={dispatchDate}
                max={
                  new Date()
                    .toISOString()
                    .split("T")[0]
                }
                onChange={(e) =>
                  setDispatchDate(
                    e.target.value
                  )
                }
              />
            </div>

            {/* SHOW */}

            <div className="col-md-2 d-flex align-items-end">

              <button
                className="btn btn-primary w-100"
                onClick={loadData}
              >
                Show
              </button>
            </div>
          </div>

          {/* ================= TABLE ================= */}

          <div className="table-responsive">

            <table className="table table-bordered">

              <thead>

                <tr>
                  <th>
                    Request By
                  </th>
                  <th>Name</th>
                  <th>Item</th>
                  <th>
                    Req Qty
                  </th>
                  <th>
                    Disp Qty
                  </th>
                  <th>
                    Enter Qty
                  </th>
                  <th>Status</th>
                </tr>

              </thead>

              <tbody>

                {data.length >
                0 ? (

                  data.map(
                    (d, i) => (

                      <tr key={i}>

                        <td>
                          {
                            d.OrderBy
                          }
                        </td>

                        <td>
                          {d.Name}
                        </td>

                        <td>
                          {
                            d.ItemName
                          }
                        </td>

                        <td>
                          {
                            d.NoOfItems
                          }
                        </td>

                        <td>
                          {d.NoOfItemsDisp ||
                            0}
                        </td>

                        <td>

                          <input
                            type="number"
                            className="form-control"
                            min="1"
                            step="1"
                            value={
                              d.qty
                            }
                            disabled={
                              Number(
                                d.NoOfItemsDisp ||
                                  0
                              ) >=
                              Number(
                                d.NoOfItems ||
                                  0
                              )
                            }
                            onKeyDown={(
                              e
                            ) => {

                              const blocked =
                                [
                                  "-",
                                  "+",
                                  "e",
                                  "E",
                                  ".",
                                ];

                              if (
                                blocked.includes(
                                  e.key
                                )
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onPaste={(
                              e
                            ) => {

                              const pasted =
                                e.clipboardData.getData(
                                  "text"
                                );

                              if (
                                !/^\d+$/.test(
                                  pasted
                                )
                              ) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(
                              e
                            ) =>
                              handleQtyChange(
                                i,
                                e.target
                                  .value
                              )
                            }
                          />
                        </td>

                        <td>
                          {
                            d.status
                          }
                        </td>
                      </tr>
                    )
                  )

                ) : (

                  <tr>

                    <td
                      colSpan="7"
                      className="text-center"
                    >
                      No Data Found
                    </td>

                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* DISPATCH */}

          <button
            className="btn btn-success"
            onClick={
              dispatchItems
            }
            disabled={
              !data.length ||
              loading
            }
          >
            {loading
              ? "Dispatching..."
              : "Dispatch"}
          </button>
        </>
      )}

      {/* ================= VIEW ================= */}

      {tab === "view" && (
        <>
          <div className="row mb-3">

            <div className="col-md-4">

              <label className="form-label">
                Request No
              </label>

              <select
                className="form-control"
                value={
                  viewMastId
                }
                onChange={(e) =>
                  setViewMastId(
                    e.target.value
                  )
                }
              >
                <option value="">
                  Select
                </option>

                {masters.map(
                  (m) => (
                    <option
                      key={
                        m.ReqIndentMastId
                      }
                      value={
                        m.ReqIndentMastId
                      }
                    >
                      {
                        m.ReqIndentNo
                      }
                    </option>
                  )
                )}
              </select>
            </div>

            <div className="col-md-2 d-flex align-items-end">

              <button
                className="btn btn-primary w-100"
                onClick={
                  loadViewData
                }
              >
                Show
              </button>
            </div>
          </div>

          {/* VIEW TABLE */}

          <div className="table-responsive">

            <table className="table table-bordered">

              <thead>

                <tr>
                  <th>
                    Request By
                  </th>
                  <th>Name</th>
                  <th>Item</th>
                  <th>
                    Req Qty
                  </th>
                  <th>
                    Disp Qty
                  </th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>

              </thead>

              <tbody>

                {viewData.length >
                0 ? (

                  viewData.map(
                    (d, i) => (

                      <tr key={i}>

                        <td>
                          {
                            d.OrderBy
                          }
                        </td>

                        <td>
                          {d.Name}
                        </td>

                        <td>
                          {
                            d.ItemName
                          }
                        </td>

                        <td>
                          {
                            d.NoOfItems
                          }
                        </td>

                        <td>
                          {
                            d.NoOfItemsDisp
                          }
                        </td>

                        <td>
                          {
                            d.Status
                          }
                        </td>

                        <td>
                          {d.DateOfDispatch
                            ? new Date(
                                d.DateOfDispatch
                              ).toLocaleDateString()
                            : "-"}
                        </td>
                      </tr>
                    )
                  )

                ) : (

                  <tr>

                    <td
                      colSpan="7"
                      className="text-center"
                    >
                      No Data Found
                    </td>

                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default DispatchIndent;